export default __webpack_public_path__ + "static/media/calculator-legend-disabled-02.02ad50ba.svg";